<template lang="html">
    <div>
      <div class="form-group">
        <label for="name">Nombre</label>
        <input type="text" v-model="award.name" class="form-control">
      </div>
      <div class="form-group">
        <label for="name">Class</label>
        <input type="text" v-model="award.class" class="form-control">
      </div>
    </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: [ 'award' ],
  computed: {},
  methods: {},
  components: {}
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** AwardsForm.vue?03286f10
 **/